module.exports = __webpack_public_path__ + "media/images/background-6-3c76fae34725582ff5d0fce72539c37c.svg";